import React from "react";
import "../Philosophy.css";

import { FaQuoteLeft, FaLightbulb } from "react-icons/fa";

const Philosophy = () => {
  return (
    <section className="philosophy">

      <div className="philosophy-overlay"></div>

      <div className="company-container">

        <div className="quote-icon">
          <FaQuoteLeft />
        </div>

        <span className="section-tag philosophy-tag">
          OUR PHILOSOPHY
        </span>

        <blockquote>
          Technology should simplify complexity,
          inspire innovation, and create meaningful
          business impact.
        </blockquote>

        <p className="philosophy-description">
          At VisionVote Technologies, we believe software is more than code—it
          is a strategic investment that empowers organizations to innovate,
          improve efficiency, and achieve sustainable growth. Every solution we
          build is guided by trust, collaboration, quality, and a deep
          understanding of our clients' business goals.
        </p>

        <div className="philosophy-line"></div>

        <div className="philosophy-footer">

          <FaLightbulb />

          <span>
            "We don't just build software. We build technology that enables
            businesses to grow with confidence."
          </span>

        </div>

      </div>

    </section>
  );
};

export default Philosophy;